import { InjectionToken, Injector, Pipe, PipeTransform } from '@angular/core';
import { AvailablePipes } from './../../models/generic-pipe.models';

@Pipe({
  name: 'genericPipe',
})
export class GenericPipePipe implements PipeTransform {
  constructor(private injector: Injector) {}

  transform(
    value: any,
    requiredPipe?: InjectionToken<AvailablePipes>,
    pipeArgs?: string | string[] | undefined
  ): any {
    if (!requiredPipe) return value;

    const pipe = this.injector.get<AvailablePipes & PipeTransform>(
      requiredPipe
    );

    return pipe.transform.call(pipe, value, pipeArgs);
  }
}
